export class Quotation {
	quotationid:number;
	requirementid:number;
	vendorid:number;
	vendorname:string;
	amount: number;
	status: number;
	quotationpath: string;
    createdon: Date;
	createdby: string;
	approvedstatus:number;
}